// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-pop-analysis[data-v-60f3b17b]{position:relative;padding-top:22px;border-top:1px solid #e8e9eb}.video-pop-analysis .label-icon[data-v-60f3b17b]{flex-shrink:0;width:14px;margin-right:5px}.video-pop-analysis .analysis-label[data-v-60f3b17b]{display:flex;flex-wrap:wrap;align-items:center;font-weight:500;margin-bottom:5px;font-size:14px;line-height:20px}.video-pop-analysis .analysis-content[data-v-60f3b17b]{color:#808588;font-size:13px;line-height:20px}", ""]);
// Exports
module.exports = exports;
